import { alpha } from '@material-ui/core/styles';
import { styled } from '../../../core/theme/styled';
import { Button, ButtonProps } from './Button';

const StyledButton = styled(Button)`
  && {
    padding: 0;
    margin: 0;
    min-width: unset;
    font-weight: ${(props) => props.theme.font.weights.regular};
  }
`;

export const TextButton: React.FC<ButtonProps> = ({ ...props }) => (
  <StyledButton size="small" {...props} />
);

export const UnderlinedTextButton = styled.button`
  font-family: ${(props) => props.theme.font.face};
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  /* reset button styles */
  border: none;
  background: transparent;
  padding: 0;
  appearance: none;
  font-size: inherit;
  outline: none;

  &:focus {
    box-shadow: 0 0 0 0.2rem ${({ theme }) => alpha(theme.configuration.primaryColor, 0.25)};
  }
`;
